<template>
  <v-dialog v-model="open" :width="width" persistent>
    <v-card v-if="item">
      <v-card-title>
        Nazwa: {{ item.name }}
        <br />
        Opis: {{ item.label }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <br />
        <div v-if="item.inputType === 'COLOR'" class="d-flex">
          <v-color-picker
            v-model="tempValue"
            canvas-height="300"
            class="ma-auto"
            hide-mode-switch
            mode="hexa"
            width="400"
          ></v-color-picker>
        </div>
        <div v-else-if="item.inputType === 'CHECKBOX'">
          <v-checkbox v-model="tempValue" label="Wartość"></v-checkbox>
        </div>
        <div v-else-if="item.inputType === 'TEXTBOX'">
          <ckeditor
            :config="editorConfig"
            editorUrl="https://cdn.ckeditor.com/4.14.0/full-all/ckeditor.js"
            v-model="tempValue"
          ></ckeditor>
        </div>
        <div v-else-if="item.inputType === 'QUEUESTATUSDISPLAYMODE'">
          <v-select
            v-model="tempValue"
            :items="queueStatusDisplayMode"
            item-text="text"
            item-value="value"
          ></v-select>
        </div>
        <div v-else-if="item.inputType === 'RESERVATIONMODETYPE'">
          <v-select
            v-model="tempValue"
            :items="reservationMode"
            item-text="text"
            item-value="value"
          ></v-select>
        </div>
        <div v-else-if="item.inputType === 'SMSAPITYPE'">
          <v-select
            v-model="tempValue"
            :items="smsApiType"
            item-text="text"
            item-value="value"
          ></v-select>
        </div>
        <div v-else-if="item.inputType === 'CAPTCHAPROVIDERTYPE'">
          <v-select
            v-model="tempValue"
            :items="captchaProvider"
            item-text="text"
            item-value="value"
          ></v-select>
        </div>
        <div v-else>
          <v-text-field v-model="tempValue" label="Wartość"></v-text-field>
        </div>
        <v-switch label="Ukryte" v-model="item.hide"></v-switch>
        <br />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="success" @click="save">Zapisz</v-btn>
        <v-btn color="error" @click="cancel">Anuluj</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  captchaProvider,
  queueStatusDisplayMode,
  reservationMode,
  smsApiType,
} from "@/helpers";
import CKEditor from "ckeditor4-vue";

export default {
  components: {
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      editorConfig: {
        height: 500,
        versionCheck: false,
      },
      queueStatusDisplayMode,
      reservationMode,
      smsApiType,
      captchaProvider,
      open: false,
      item: null,
      tempValue: "",
      width: 600,
    };
  },
  watch: {
    open: function (newVal) {
      if (!newVal) {
        this.item = null;
        this.tempValue = "";
      }
    },
  },
  methods: {
    save() {
      var vm = this;
      this.item.value = this.tempValue;
      this.$http
        .post("/Configuration/UpdateConfiguration", this.item)
        .finally(() => {
          vm.open = false;
        });
    },
    cancel() {
      this.open = false;
    },
    editConfig(item) {
      this.width = item.inputType === "TEXTBOX" ? 1200 : 600;
      this.tempValue = item.value;
      this.item = item;
      this.open = true;
    },
  },
};
</script>
